import React__default from 'react';

var ColorModeContext = React__default.createContext({
    colorMode: "light",
    toggleColorMode: function () { },
});
var getColorMode = function (_a) {
    var defaultMode = _a.defaultMode, mode = _a.mode;
    if (mode) {
        return mode;
    }
    var storageValue;
    try {
        if (typeof window !== "undefined") {
            storageValue = localStorage.getItem("colorMode");
        }
    }
    catch (e) {
        // Ignore error
    }
    if (!storageValue || !["light", "dark"].includes(storageValue)) {
        return defaultMode || "light";
    }
    return storageValue;
};
var useColorMode = function (options) {
    var _a = React__default.useState(getColorMode(options)), colorMode = _a[0], setColorMode = _a[1];
    React__default.useEffect(function () {
        if (options.mode) {
            setColorMode(options.mode);
        }
    }, [options.mode]);
    var toggleColorMode = React__default.useCallback(function () {
        setColorMode(function (prevState) {
            var mode = prevState === "light" ? "dark" : "light";
            try {
                if (typeof window !== "undefined") {
                    localStorage.setItem("colorMode", mode);
                }
            }
            catch (e) {
                // Ignore error
            }
            return mode;
        });
    }, []);
    return { colorMode: colorMode, toggleColorMode: toggleColorMode };
};

export { ColorModeContext, useColorMode };
//# sourceMappingURL=ColorModeContext.js.map
